import { vappContainer, VApplication } from '../../../../../application';
import { logger as log } from '@common/logger';
import { DraftAppPageService } from '../../../services';

const MODULE_NAME = 'profile.machines.states.deleteDraft';

const getSrv = () => {
  return vappContainer.get<DraftAppPageService>(
    DraftAppPageService.displayName
  );
};

export const deleteDraft = async (context: any, event: any) => {
  const currentState = 'DELETE_USER';
  const method = 'revokeCred';

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.agent.getDeleteDraft(event?.payload);
      if (content) {
        return resolve({
          key: 'DELETE_USER_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'User deletion failed';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'DELETE_USER_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      let _msg = err?.message?.replace('GraphQL error:', '');
      return reject({
        key: 'DELETE_USER_FAILED',
        value: _msg,
      });
    }
  });
};
